
import { JSONSchema7, JSONSchema7Definition } from "json-schema";
import { KeyInfo } from "data/types";
import { RegistryFieldsType, RegistryWidgetsType  } from "@rjsf/utils";
import { PrimaryKeyField } from "./PrimaryKeyField";
import { ForeignKeyField } from "./ForeignKeyField";
import { ImageField } from "./ImageField";
import FileInputField from "./FileField";
import NumberField from "./NumberField";
import Form from "@rjsf/core";

function exploreSchema(schema: JSONSchema7, path: string[]){
    const v = path.reduce((current: JSONSchema7 | JSONSchema7Definition | null, pathElement)=>{
     
      if(!current){
        return null;
      }
  
      if(typeof current === 'boolean'){
        return null;
      }

      if(pathElement === '[]'){
        if(!current.items || typeof current.items === 'boolean'){
          console.error(`Array properties expected in ${path}`)
          return null;
        }

        if(Array.isArray(current.items)){
          console.error('Schema is too complex')
          return null;
        }
        return current.items;
      }
  
      if(!current.properties){
        return null;
      }
  
      return current.properties[pathElement]
  
    }, schema)
  
    if(typeof v === 'boolean')
      return null;
  
    return v;
  }

  
  export const CartaWidgetFields: RegistryFieldsType ={
    'pk': PrimaryKeyField,
    'fk': ForeignKeyField,
    'image': ImageField,
    NumberField
  }

  export const CartaWidgets: RegistryWidgetsType = {
    FileWidget: FileInputField
  }

  export const CartaTemplates: ConstructorParameters<typeof Form>[0]['templates'] = {}

  
  function assignImageIds(schema: JSONSchema7){
    if(!schema.properties) return;
    Object.values(schema.properties).forEach(prop => {
      if(typeof prop === 'boolean') return;
      if((prop as any)['cl-format'] === 'image'){
        prop.$id = 'image';
      }
      if(prop.type === 'object'){
        assignImageIds(prop);
      }
      if(prop.items && typeof prop.items === 'object' && !Array.isArray(prop.items)){
        assignImageIds(prop.items as JSONSchema7);
      }
    });
  }

  export function assignKeyIds(schema: JSONSchema7, keyInfo: KeyInfo){
    if(keyInfo.primaryKeyPath){

      const sampleId = exploreSchema(schema, keyInfo.primaryKeyPath);
      if(sampleId){
        sampleId.$id = 'pk';
      }
    }

    if(keyInfo.foreignKeyPaths){
      keyInfo.foreignKeyPaths.forEach(fk=>{
        const foreignKey = exploreSchema(schema, fk);
        if(foreignKey){
          foreignKey.$id = 'fk';
        }
      })
    }

    assignImageIds(schema);
  }